import Chip from '@mui/joy/Chip'

export function AttendeeChip({ email, name }: { email: string; name?: string }) {
    return (
        <Chip variant="outlined" size="sm">
            {name ? `${name} <${email}>` : email}
        </Chip>
    )
}
